export const REACT_QUERY_FEEDBACK_DRAWER_KEYS = {
  applicableCompetencies: 'applicableCompetencies',
  fillRequestedFeedback: 'fillRequestedFeedback',
};

export const MESH_MAVEN_INVALID_STATE_TOOLTIP =
  'Type at least 15 characters to use Maven to improve the quality and rephrase your feedback. Works with English only.';
export const MESH_MAVEN_VALID_STATE_TOOLTIP =
  'Improve the quality of your feedback and rephrase it using Maven. Works with English only.';

export const MESH_MAVEN_DEI_CONSTANTS = {
  Whitelisted: {
    issue: "Carries racial connotations by associating 'white' with positive access or approval.",
    suggestion: ['Allowed', 'Permitted', 'Approved'],
  },
  'You guys': {
    issue: 'Excludes non-binary and female individuals.',
    suggestion: ['You all', 'Everyone', 'Team'],
  },
  Crazy: {
    issue: 'Stigmatizes mental health.',
    suggestion: ['Amazing', 'Unbelievable', 'Impressive'],
  },
  Blacklisted: {
    issue: 'Carries negative racial connotations.',
    suggestion: ['Blocked', 'Restricted', 'Prohibited'],
  },
  Chairman: {
    issue: 'Gendered job title, excludes female and non-binary individuals.',
    suggestion: ['Chairperson', 'Chair'],
  },
  'Man up': {
    issue: 'Reinforces traditional gender roles.',
    suggestion: ['Be strong', 'Show resilience', 'Take responsibility'],
  },
  Housewife: {
    issue: 'Implies outdated gender roles.',
    suggestion: ['Homemaker', 'Stay-at-home parent'],
  },
  'Grow a pair': {
    issue: 'Gendered phrase, implies stereotypical masculinity.',
    suggestion: ['Be brave', 'Step up', 'Show courage'],
  },
  Lame: {
    issue: 'Demeaning to people with physical disabilities.',
    suggestion: ['Unimpressive', 'Unappealing', 'Not great'],
  },
  Insane: {
    issue: 'Stigmatizes mental health.',
    suggestion: ['Unbelievable', 'Incredible', 'Surprising'],
  },
  Psycho: {
    issue: 'Stigmatizes mental illness.',
    suggestion: ['Erratic', 'Intense', 'Extreme'],
  },
  Crippled: {
    issue: 'Derogatory toward people with disabilities.',
    suggestion: ['Hindered', 'Impeded', 'Limited'],
  },
  Retarded: {
    issue: 'Offensive to individuals with intellectual disabilities.',
    suggestion: ['Outdated', 'Underdeveloped', 'Slow'],
  },
  'Blind spot': {
    issue: 'Insensitive to those with visual disabilities.',
    suggestion: ['Overlooked area', 'Unseen area', 'Gap'],
  },
  Manpower: {
    issue: 'Gendered term implying male workforce.',
    suggestion: ['Workforce', 'Staff', 'Personnel'],
  },
  Mankind: {
    issue: 'Implies humanity as male.',
    suggestion: ['Humanity', 'Humankind', 'People'],
  },
  'Man-made': {
    issue: 'Gendered term, often used for artificial items.',
    suggestion: ['Artificial', 'Synthetic', 'Human-made'],
  },
  Middleman: {
    issue: 'Gendered term for an intermediary.',
    suggestion: ['Intermediary', 'Go-between'],
  },
  Salesman: {
    issue: 'Gender-specific term in sales.',
    suggestion: ['Salesperson', 'Sales Representative'],
  },
  'Sanity check': {
    issue: "Ableist language, implies that something is 'insane' if incorrect.",
    suggestion: ['Quick check', 'Review', 'Validation check'],
  },
  'Tone-deaf': {
    issue: 'Insensitive to individuals with hearing impairments.',
    suggestion: ['Insensitive', 'Unaware'],
  },
  'Grandfathered in': {
    issue: 'Historically rooted in discriminatory practices (grandfather clauses used to disenfranchise Black voters).',
    suggestion: ['Legacy status', 'Exempted'],
  },
  'Man in the middle': {
    issue: 'Gendered technical term.',
    suggestion: ['Intermediary Attack', 'MitM Attack'],
  },
};
